<input-form (enter)="enter.emit($event)" [inputControl]="emailFormControl" [placeholder]="'Nhập địa chỉ Email'" [faIcon]="icons.faEnvelope"> </input-form>
